/**
 * Safe error message extraction — handles unknown catch parameter.
 */
export function getErrorMessage(err: unknown): string {
  if (err instanceof Error) return err.message;
  if (typeof err === 'string') return err;
  // Handle Supabase-style error objects: { message: string }
  if (err != null && typeof err === 'object' && 'message' in err && typeof (err as Record<string, unknown>).message === 'string') {
    return (err as Record<string, unknown>).message as string;
  }
  return String(err);
}

/**
 * Truncate error message for toast display — prevents UI overflow and info leakage.
 * @param err   The caught error value
 * @param maxLen  Maximum characters (default 120)
 */
export function toastSafeMessage(err: unknown, maxLen = 120): string {
  const msg = getErrorMessage(err);
  return msg.length > maxLen ? msg.slice(0, maxLen) + '…' : msg;
}

/**
 * Sanitize user-generated text content — strip HTML tags to prevent XSS.
 * This is a defense-in-depth layer; primary protection is Supabase RLS + React's auto-escaping.
 */
export function sanitizeText(input: string): string {
  return input.replace(/<[^>]*>/g, '');
}
